module.exports = __webpack_public_path__ + "img/seabrokers-group-logo- small.02e4beef.png";